import React, { useState } from "react";
import { Input } from "antd";
import { noop } from "lodash";
import { RARadioGroup } from "./RARadioGroup";

const { TextArea } = Input;

export const RARadioGroupReason = ({ value = "I receive too many emails", onChange = noop, ...props }) => {
	const [specify, setSpecify] = useState(null);

	return (
		<>
			<RARadioGroup
				onChange={(v) => {
					if (v === "Other" && specify) {
						onChange("Other" + " " + specify);
					} else {
						onChange(v);
					}
				}}
				value={value.includes("Other") ? "Other" : value}
				options={[
					{
						value: "I receive too many emails",
						label: "I receive too many emails",
					},
					{
						value: "The content is not relevant to me",
						label: "The content is not relevant to me",
					},
					{
						value: "I'm no longer interested",
						label: "I'm no longer interested",
					},
					{
						value: "The emails look like spam",
						label: "The emails look like spam",
					},
					{
						value: "Other",
						label: "Other",
					},
				]}
				{...props}
			/>
			{value.includes("Other") && (
				<TextArea
					style={{ marginTop: 8 }}
					rows={4}
					placeholder="Please enter your reason here"
					value={specify}
					onChange={(e) => {
						setSpecify(e.target.value);
						onChange("Other" + " " + e.target.value);
					}}
				/>
			)}
		</>
	);
};
